import styled from "styled-components";
import checkboxChecked from "../../assets/icons/checkbox_checked.svg";

export const Checkbox = styled.input.attrs({type: 'checkbox'})`
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border: 1px solid #DFE0EB;
  border-radius: 5px;
  cursor: pointer;
  transition: all 300ms ease;
  flex-shrink: 0;

  :hover {
    border: 2px solid #DFE0EB;
  }

  :checked {
    // @ts-expect-error
    background-image: url(${checkboxChecked as any});
    background-repeat: no-repeat;
    background-position: center;
    background-color: #253292;
    border-radius: 4px;
    border: none;
  }

  :disabled {
    border-color: #c0c0c0;
    background-color: #c0c0c0;

    :hover {
      border: 1px solid #DFE0EB;
      cursor: default;
    }
  }
`

interface CheckboxLabelProps {
    textSide: 'left' | 'right'
}

export const CheckboxLabel = styled.label<CheckboxLabelProps>`
  display: flex;
  align-items: center;
  justify-content: left;
  font-style: normal;
  font-size: 12px;
  line-height: 16px;
  color: ${({theme}) => theme.gray};

  input {
    ${({textSide}: CheckboxLabelProps) => 'margin-' + textSide + ':11px;'}
  }
`
